import { calculateLocatinVars } from '../../../libs/browser';
import { getLanguageList } from '../../../libs/date';
import { logoutAccount } from '../../../libs/state';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import Context from '../../../provider';
import HelpSharpIcon from '@mui/icons-material/HelpSharp';
import IconCPolicy from '../../../assets/hkdc/icons/SettingCPolicy';
import IconContact from '../../../assets/hkdc/icons/SettingContact';
import IconLanguage from '../../../assets/hkdc/icons/SettingLanguage';
import IconLogout from '../../../assets/hkdc/icons/SettingLogout';
import IconPPolicy from '../../../assets/hkdc/icons/SettingPPolicy';
import IconSettingTag from '../../../assets/hkdc/icons/SettingTagIcon';
import IconTerms from '../../../assets/hkdc/icons/SettingTerms';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PersonIcon from '@mui/icons-material/Person';
import React, { useContext, useEffect, useRef } from 'react';
import ToggleGroupComponent from '../../../components/ToggleGroupComponent';
import config from '../../../config';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileSettings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const scrollRef = useRef();
  const isScrolling = useIsScrolling(scrollRef.current);

  const { init, dispatch, me } = useContext(Context);

  // This page only allow logged in user
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [init, me, navigate]);

  const handleLogout = (e) => {
    e.preventDefault();
    logoutAccount({ dispatch });

    navigate(`${config.basename}`);
  };

  const languageChange = (value) => {
    console.log('Language Change', value);
  };

  return (
    (
      <div className='mobile-settings-page'>
        <BackCloseBarComponent onClick={() => navigate(-1)} />
        <div ref={scrollRef} className="y-overflow content-container">
          <div className="setting-title-container">
            <div className="title-text-cont">
              <div className="title-text">
                {t('setting.title')}
              </div>
            </div>
            <IconSettingTag
              className="setting-tag-icon"
              size="large" />
          </div>
          <div className="setting-list-container">
            <div className="user-setting-cont">
              {
                me && me?.status !== 'new' &&
                <div className="setting-item" onClick={() => {
                  navigate(`${config.basename}profile`);
                }}>
                  <div className="icon-title-cont">
                    <PersonIcon
                      style={{ color: '#E53323' }}
                      className="icon"
                      size="large" />
                    <div className="title-text">
                      {t('setting.profile')}
                    </div>
                  </div>
                  <KeyboardArrowRightIcon
                      className="icon"
                      size="large" />
                </div>
              }
              {(config.menu?.topSettingItems ?? []).length > 0 && (
                <>
                  {(config.menu.topSettingItems ?? []).map((item, index) => (
                    <div key={index} className="setting-item" onClick={() => {
                      setTimeout(() => {
                        navigate(`${config.basename}${item?.url}`);
                      }, 200);
                    }}>
                      <div className="icon-title-cont">
                        {
                          item?.title.includes('faq') &&
                          <HelpSharpIcon
                            style={{ color: '#E53323' }}
                            className="icon"
                            size="large" />
                        }
                        {
                          item?.title.includes('contact-info') &&
                          <IconContact
                            className="icon"
                            size="large" />
                        }
                        <div className="title-text">
                          {t(item?.title)}
                        </div>
                      </div>
                      <KeyboardArrowRightIcon
                          className="icon"
                          size="large" />
                    </div>
                  ))}
                </>
              )}
            </div>
            <div className="language-item-cont">
              <div className="icon-title-cont">
                <IconLanguage
                  className="icon"
                  size="large" />
                <div className="title-text">
                  {t('setting.language')}
                </div>
              </div>
              <ToggleGroupComponent
                value={'en'}
                groupList={getLanguageList()}
                onChange={languageChange}
              />
            </div>
            <div className="policy-setting-cont">
              {(config.menu?.bottomSettingItems ?? []).length > 0 && (
                <>
                  {(config.menu.bottomSettingItems ?? []).map((item, index) => (
                    <div key={index} className="setting-item" onClick={() => {
                      setTimeout(() => {
                        navigate(`${config.basename}${item?.url}`);
                      }, 200);
                    }}>
                      <div className="icon-title-cont">
                        {
                          item?.title.includes('terms') &&
                          <IconTerms
                            style={{ color: '#E53323' }}
                            className="icon"
                            size="large" />
                        }
                        {
                          item?.title.includes('privacy') &&
                          <IconPPolicy
                            className="icon"
                            size="large" />
                        }
                        {
                          item?.title.includes('copyright') &&
                          <IconCPolicy
                            className="icon"
                            size="large" />
                        }
                        <div className="title-text">
                          {t(item?.title)}
                        </div>
                      </div>
                      <KeyboardArrowRightIcon
                          className="icon"
                          size="large" />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          {
            me && me?.status !== 'new' &&
            <div className="logout-btn-cont">
              <div className="logout-btn" onClick={handleLogout}>
                <IconLogout
                  className="icon"
                  size="large" />
                <div className="title-text">
                  {t('common.logout')}
                </div>
              </div>
            </div>
          }
          <div style={{ height: '10rem' }} />
        </div>
      </div>
    )
  );
}